export default __webpack_public_path__ + "static/media/3.961f5aad.jpg";